import brandPortalMarketingInsiderPartnership from "@faire/web-api/routes/brand-portal/marketing/insider-partnership";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var InsiderFreeShippingIA = function InsiderFreeShippingIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "lu7149",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Het Insider Partner-programma"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " is een programma waaraan merken kunnen deelnemen om hun groei te stimuleren door nog meer gratis verzending aan te bieden aan Insiders (de topkopers op Faire) zonder alle kosten zelf te hoeven dekken."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return InsiderPartnershipFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "5e16Bk",
    defaultMessage: [{
      "type": 0,
      "value": "Door meer gratis verzending aan te bieden als Insider Partner kun je:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "MQrpjL",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Nieuwe klanten converteren:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " het is 30% waarschijnlijker dat retailers kopen als ze gratis verzending zien."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "d2Bx+/",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Loyaliteit opbouwen bij bestaande klanten:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " retailers plaatsen 30% meer herbestellingen als ze gratis verzending krijgen. Ze bestellen vaker en plaatsen grotere bestellingen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "WQu+9o",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Meer aandacht krijgen van topkopers op Faire:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " Insiders zorgen voor 80% van de verkopen op Faire en bestellen 2x meer dan retailers die geen Insider zijn. Ze kopen voornamelijk in bij merken met gratis verzending."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "f8saKN",
    defaultMessage: [{
      "type": 0,
      "value": "Als merk kun je ervoor kiezen om Insider Partner te worden als je wilt samenwerken met Faire om meer gratis verzending op je producten aan te kunnen bieden voor Insiders. Wij betalen voor gratis verzending van in aanmerking komende Insider-bestellingen via de marktplaats. Jij betaalt voor gratis verzending van in aanmerking komende Insider-bestellingen via Faire Direct."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ojPt35",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt de "
    }, {
      "children": [{
        "type": 0,
        "value": "pagina van het Insider-partnerprogramma"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " in je portaal bezoeken om gepersonaliseerde schattingen te zien van hoe de gratis verzending, omzet en kosten van je merk eruit kunnen zien als Insider Partner."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return InsiderPartnershipFormatting(chunks);
      }
    }
  })));
};
var InsiderPartnershipFormatting = function InsiderPartnershipFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMarketingInsiderPartnership(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};